import { render, staticRenderFns } from "./MinhasLicencas.vue?vue&type=template&id=6635849c&scoped=true&"
import script from "./MinhasLicencas.vue?vue&type=script&lang=js&"
export * from "./MinhasLicencas.vue?vue&type=script&lang=js&"
import style0 from "./MinhasLicencas.vue?vue&type=style&index=0&id=6635849c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6635849c",
  null
  
)

export default component.exports